let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ecERA")).then(() => parcelRequire('Gk4RP'));